import SuperEllipse from "react-superellipse";
import ResizeListener from "../../utility/ResizeListener";
import {
  LIGHT_GREY_BG_MODAL,
  SIDEBAR_COLOR,
  WHITE_COLOR,
  LIGHT_TEXT_COLOR,
} from "../resources/colorsManager";
import { PX_10, PX_16, PX_20 } from "../resources/valuesManager";

const SidebarLayout = ({ menu, passCurrentTab, activeTab }) => {
  const { height } = ResizeListener();

  return (
    <SuperEllipse
      r1={0.01}
      r2={0.2}
      style={{
        height: height * 0.85,
        width: "15%",
        border: "0px",
        borderRadius: PX_20,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        paddingTop: PX_20,
        boxSizing: "border-box",
        backgroundColor: SIDEBAR_COLOR,
        minWidth: "180px",
        position: "sticky",
        top: 0,
      }}
    >
      {menu &&
        menu.map((route, index) =>
          route?.headerName ? (
            <p
              style={{
                fontSize: 14,
                textAlign: "left",
                width: "100%",
                marginLeft: 25,
                color: WHITE_COLOR,
                opacity: 0.8,
                marginTop: 30,
              }}
            >
              {route?.headerName}
            </p>
          ) : (
            <div
              key={index}
              style={{
                textDecoration: "none",
                textAlign: "center",
                width: "100%",
                display: "flex",
                flexDirection: "row-reverse",
                marginTop: route?.toHeading ? 0 : "20px",
                cursor: "pointer",
              }}
              onClick={() => passCurrentTab(route?.key)}
            >
              <div
                style={{
                  minHeight: 20,
                  flex: 3.5 / 4,
                  width: "100%",
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                  opacity: activeTab === route.key ? 1 : 0.6,
                }}
              >
                {route?.icon && (
                  <img
                    src={route?.icon}
                    style={{
                      marginRight: 10,
                      width: "20px",
                      height: "20px",
                      objectFit: "contain",
                    }}
                    alt="Routes"
                  />
                )}
                <p
                  style={{
                    fontWeight: "500",
                    fontSize: PX_16,
                    marginLeft: PX_10,
                    color: WHITE_COLOR,
                    margin: 0,
                  }}
                  className="roboto"
                >
                  {route.name}
                </p>
                {activeTab === route.key && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      alignSelf: "center",
                      flex: 1,
                    }}
                  >
                    <div
                      style={{
                        backgroundColor: "white",
                        height: 21,
                        width: 5,
                        display: "flex",
                        alignSelf: "center",
                        borderRadius: 10,
                        marginRight: 2,
                      }}
                    ></div>
                  </div>
                )}
              </div>
            </div>
          )
        )}
    </SuperEllipse>
  );
};

export default SidebarLayout;
